export enum Title {
  NONE,
  FIGHTBACK_CHAMPION,
  COLLECTORS_CHAMPION,
  TAG_TEAM_CHAMPION,
}

export function mapStringToTitle(input: string): Title {
  switch (input) {
    case 'Heavyweight':
      return Title.FIGHTBACK_CHAMPION
    case 'Collector':
      return Title.COLLECTORS_CHAMPION
    case 'Tagteam':
      return Title.TAG_TEAM_CHAMPION
    case 'Keine':
    default:
      return Title.NONE
  }
}

export function mapTitleToChampionString(input: Title, numberOfMedals = 0): string | null {
  switch (input) {
    case Title.FIGHTBACK_CHAMPION:
      return 'FIGHTBACK-WRESTLING Champion'
    case Title.COLLECTORS_CHAMPION:
      return (numberOfMedals === 4 ? 'Ultimate ' : '') + 'Collector Champion'
    case Title.TAG_TEAM_CHAMPION:
      return 'FIGHTBACK-WRESTLING Tag Team Champion'
    case Title.NONE:
    default:
      return null
  }
}

export function mapTitleToChampionshipString(input: Title): string | null {
  switch (input) {
    case Title.FIGHTBACK_CHAMPION:
      return 'FIGHTBACK-WRESTLING Championship'
    case Title.COLLECTORS_CHAMPION:
      return 'Collector Championship'
    case Title.TAG_TEAM_CHAMPION:
      return 'FIGHTBACK-WRESTLING Tag Team Championships'
    case Title.NONE:
    default:
      return null
  }
}
